import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TaskFilterDialogComponent } from '@portal-core/tasks/components/task-filter-dialog/task-filter-dialog.component';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatInputModule,
    MatToolbarModule
  ],
  declarations: [
    TaskFilterDialogComponent
  ],
  exports: [
    TaskFilterDialogComponent
  ]
})
export class TaskFilterDialogModule { }
